import { NcacheAzureImageResponse } from '../../models/ncache-azure-image-response';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from 'src/app/http.service';
import { CloudRegion } from 'src/app/models/cloud-region.model';
import { LicensePlan } from 'src/app/models/license-plan.model';
import { NcacheAwsImage } from 'src/app/models/ncache-aws-image.model';
import { NcacheAzureImage } from 'src/app/models/ncache-azure-image.model';
import { FreeTrialExpiryResponse } from 'src/app/models/responses/free-trial-expiry-response.model';
import { VmSize } from 'src/app/models/vm-size.model';
import Helper from 'src/app/Util/helper';
import { environment } from 'src/environments/environment';
import { EnvironmentConfiguration } from '../../models/environment-configuration';
import { NcacheAwsImageResponse } from 'src/app/models/ncache-aws-image-response';
import { LocalStorageService } from 'src/app/services/localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class CloudDeploymentService {

  name: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  buttonClick: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  model: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  deploymentUserAccountName: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  deploymentUserAdded: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  username = '';
  deploymentuser = '';
  programaticDeployment = false;
  isdeploying = false;
  isChecked = false;
  isCopyChecked = false;
  automaticDeployment = false;
  environmentConfigured = false;
  environmentConfiguration: EnvironmentConfiguration;
  selectedSubscriptionName: string;
  selectedResourceGroup: string;
  selectedVNET: string;
  selectedSubnetName: string;
  selectedVpcName: string;
  selectedGatewayName: string;
  deploymentUser: boolean;
  environmentBackButton = false;
  licensePlan: LicensePlan[] = [];
  ncacheAzureImages: NcacheAzureImageResponse[] = [];
  ncacheAwsImages: NcacheAwsImageResponse[] = [];
  cloudRegions: CloudRegion[];
  offerType = '';
  createdDeploymentUser: string = '';
  freeTrialExpiryDate: string = '';

  SubscriptionIdList: any[];
  ResourceGroupIdList: any[];
  VirtualNetworkIdList: any[];
  SubnetIdList: any[];

  VpcsList: any[];
  GatewaysList: any[];

  fromEdit: boolean = false;
  vendorName: string;
  subscriptionUid: any;
  vmSizes: VmSize[];

  constructor(private http: HttpService, private readonly localStorage: LocalStorageService) { }
  savetolocalstorage(key, value) {
    this.localStorage.setItem(key, value);
  }
  retrieveFromLocalStorage(key) {
    return this.localStorage.getItem(key);
  }
  deleteFromLocalStorage(key) {
    this.localStorage.removeItem(key);
  }
  deleteLocalStorageData() {
    this.deleteFromLocalStorage('adName');
    this.deleteFromLocalStorage('name');
    this.deleteFromLocalStorage('scopes');
    this.deleteFromLocalStorage('password');
    this.deleteFromLocalStorage('Subscription');
    this.deleteFromLocalStorage('currentTab');
    this.deleteFromLocalStorage('firstTimeDeployment');
    this.deleteFromLocalStorage('licenseName');
    this.deleteFromLocalStorage('noOfLicense');
    this.deleteFromLocalStorage('noOfServer');
    this.deleteFromLocalStorage('serverType');
    this.deleteFromLocalStorage('vmName');
    this.deleteFromLocalStorage('noOfClient');
    this.deleteFromLocalStorage('roleName');
    this.deleteFromLocalStorage('isChecked');
    this.deleteFromLocalStorage('isCopyChecked');
    this.deleteFromLocalStorage('subscriptionID');


    this.username = '';
    this.deploymentuser = '';
    this.programaticDeployment = false;
    this.isdeploying = false;
    this.isChecked = false;
    this.isCopyChecked = false;
    this.automaticDeployment = false;
    this.environmentConfigured = false;
    this.environmentConfiguration = null;
    this.selectedSubscriptionName = '';
    this.deploymentUser = false;
    this.environmentBackButton = false;
    this.licensePlan = [];
    this.ncacheAzureImages = [];
    this.cloudRegions = [];
    this.offerType = '';
    this.createdDeploymentUser = '';
  }

  getUpdatedDLLPath(version: string, operatingSystem: string): Observable<any> {
    return this.http.get(environment.api.routes.subscription.vm.dll_update_path, { version, operatingSystem });
  }

  // SOMETHING TO SAVE THE CLOUD

  getFreeTrialExpiryDate(subscriptionUid: string): Observable<FreeTrialExpiryResponse> {
    return this.http.get(environment.api.routes.get_free_trial_expiry_date, { subscriptionUid: subscriptionUid })
  }

  checkVMSizeAvailability(subscriptionId: string, vendorSubscriptionId: string, regionId: string, vmSizeId: string): Observable<any> {
    return this.http.get(environment.api.routes.check_vm_availability, { subscriptionId, vendorSubscriptionId, regionId, vmSizeId });
  }

  getDeploymentUser(subscriptionUid: string): Observable<any> {
    return this.http.get(environment.api.routes.deployment_user.get, { subscriptionUid: subscriptionUid });
  }

  getFreeTrialNCacheAzureImage(subscriptionId: string): Observable<NcacheAzureImage[]> {
    return this.http.get(environment.api.routes.environment.get_free_trial_ncache_image_for_vendor, { subscriptionUid: subscriptionId, vendorName: Helper.azureVendorName });
  }

  getFreeTrialNCacheAwsImage(subscriptionId: string): Observable<NcacheAwsImage> {
    return this.http.get(environment.api.routes.environment.get_free_trial_ncache_image_for_vendor, { subscriptionUid: subscriptionId, vendorName: Helper.awsVendorName });
  }

  saveSubParams(subscriptionUid: string, vendorName: string) {
    let returnObject = {
      subscriptionUid: subscriptionUid,
      vendorName: vendorName
    };

    this.localStorage.setItem("azureOAuthReturnObject", JSON.stringify(returnObject));
  }

  restoreSubParams(_router: Router) {
    let returnedObj = JSON.parse(this.localStorage.getItem("azureOAuthReturnObject"));

    _router.navigate([], {
      queryParams: {
        'subscriptionUid': returnedObj.subscriptionUid,
        'vendorName': returnedObj.vendorName,
      },
      queryParamsHandling: 'merge'
    });

    return {
      subscriptionUid: returnedObj.subscriptionUid,
      vendorName: returnedObj.vendorName,
    };
  }

  getCloudSubscriptions(subscriptionUid: string): Observable<import("../../models/responses/subscription-response.model").SubscriptionResponse[]> {
    return this.http.get(environment.api.routes.environment.get_cloud_subscriptions, { subscriptionUid });
  }

  getResourceGroupsFromCloudSubscription(subscriptionUid: string, azureSubscriptionId: string): Observable<import("../../models/responses/resource-group-response.model").ResourceGroupResponse[]> {
    return this.http.get(environment.api.routes.environment.get_resource_groups_from_cloud_subscription, { subscriptionUid, subscriptionId: azureSubscriptionId });
  }

  getVirtualNetworksFromResourceGroup(subscriptionUid: string, subscriptionId: string, resourceGroupName: string): Observable<import("../../models/responses/virtual-network-response.model").VirtualNetworkResponse[]> {
    return this.http.get(environment.api.routes.environment.get_vnets_from_resource_groups, { subscriptionUid, subscriptionId, resourceGroupName });
  }

  getSubnetsFromVNet(subscriptionUid: string, subscriptionId: string, resourceGroupName: string, virtualNetworkName: string): Observable<import("../../models/responses/subnet-response.model").SubnetResponse[]> {
    return this.http.get(environment.api.routes.environment.get_subnets_from_vnets, { subscriptionUid, subscriptionId, resourceGroupName, virtualNetworkName });
  }
  getVpcs(region: string, subscriptionUID: string): Observable<any[]> {
    return this.http.get(environment.api.routes.environment.get_vpcs, { subscriptionUID, region });
  }
  getSubnetsAWS(subscriptionUID,region: any, vpcId: string): Observable<any> {
    return this.http.get(environment.api.routes.environment.get_subnets_from_aws, {subscriptionUID, region, vpcId });
  }
  getVpcAttachedGateways(region: string, subscriptionUID: string): Observable<any[]> {
    return this.http.get(environment.api.routes.environment.get_vpc_attached_internet_gateway, { region, subscriptionUID });
  }

  confirmProgrammaticDeployment(ncacheSubscriptionId: string): Observable<boolean> {
    return this.http.post(environment.api.routes.deployment_user.confirm_programmatic_deployment, { ncacheSubscriptionId });
  }
}
